// Action types for fetching products
export const SYNC_PRODUCTS_REQUEST = 'SYNC_PRODUCTS_REQUEST';
export const SYNC_PRODUCTS_SUCCESS = 'SYNC_PRODUCTS_SUCCESS';
export const SYNC_PRODUCTS_FAILURE = 'SYNC_PRODUCTS_FAILURE';
export const SYNC_PRODUCTS_REST = 'SYNC_PRODUCTS_REST';
// Save data actions
export const syncStoreProductRequest = (payload) => ({
    type: SYNC_PRODUCTS_REQUEST,
    payload,
});
export const syncStoreProductSuccess = (payload) => ({
    type: SYNC_PRODUCTS_SUCCESS,
    payload,
});
export const syncStoreProductFailure = (error) => ({
    type: SYNC_PRODUCTS_FAILURE,
    payload: error,
});
export const syncStoreProductRest = () => ({
    type: SYNC_PRODUCTS_REST,
});
